module.exports = __webpack_public_path__ + "img/base.a5222415.png";